function initializeSlider() {
  var logosSliderContainer = document.querySelectorAll(".logo-list .logos");
  logosSliderContainer.forEach(function (container) {
    new Swiper(container, {
      slidesPerView: 3.3,
      slidesPerColumn: 1,
      spaceBetween: 15,
      breakpoints: {
        640: {
          slidesPerView: 4.3,
          spaceBetween: 15,
        },
        768: {
          slidesPerView: 5.3,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: "auto",
        },
      },
    });
  });
}

document.addEventListener("DOMContentLoaded", function () {
  initializeSlider();
});
